module.exports = __webpack_public_path__ + "4d3b81c6a9b42dc1db0c93cbde8d42b8.png";